import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerComponent } from './components/loading-spinner/spinner.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { DistanceUnitPipe } from './custom-pipes/distanceUnit.pipe';
import { StopIconComponent } from './components/stop-icon/stop-icon.component';
import { ModalAlertComponent } from './modal-alert/modal-alert.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DisplayCurrencyPipe } from './custom-pipes/displayCurrency.pipe';
import { ModusAppBrandingComponent } from './components/modus-app-branding/modus-app-branding.component';
import { ReportsDistanceUnitPipe } from './custom-pipes/reportsDistanceUnit.pipe';
import { TruncateStringPipe } from './custom-pipes/truncateString.pipe';

@NgModule({
  declarations: [
    LoadingSpinnerComponent,
    SpinnerComponent,
    DistanceUnitPipe,
    DisplayCurrencyPipe,
    TruncateStringPipe,
    ReportsDistanceUnitPipe,
    StopIconComponent,
    ModalAlertComponent,
    ModusAppBrandingComponent,
  ],
  imports: [CommonModule, ModalModule.forRoot()],
  exports: [
    LoadingSpinnerComponent,
    SpinnerComponent,
    DistanceUnitPipe,
    DisplayCurrencyPipe,
    ReportsDistanceUnitPipe,
    StopIconComponent,
    ModalAlertComponent,
    ModusAppBrandingComponent,
  ],
})
export class SharedModule {}
